<article
  *ngFor="let post of posts$ | async"
  class="card">
  <div class="card-body">
    <h4>
      <a [routerLink]="['/posts', post.id, 'view']">{{ post.title }}</a>
    </h4>
    <div class="card-subtitle mb-2 text-muted">{{ post.date | date: 'short' }}</div>

    <div>{{ post.text }}</div>
  </div>
</article>
